module.exports = __webpack_public_path__ + "static/media/website-12.e0e1ba15.png";